import { render, staticRenderFns } from "./Pagadas.vue?vue&type=template&id=2fb2329d&"
import script from "./Pagadas.vue?vue&type=script&lang=ts&"
export * from "./Pagadas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports